module.exports = __webpack_public_path__ + "static/media/logowhite.60bb6ead.png";